import { effect, inject, signal, untracked } from '@angular/core';
import { signalStoreFeature, type, withProps } from '@ngrx/signals';
import { proxyListViewSignal } from 'state-data';
import { ProductStore } from 'products-data';

/**
 * Provides `promotionItems` — a `ListViewSignal<ProductEntity>` for the selected promotion.
 *
 * Requires `withPromotionEntity` (or any feature that exposes `setSelectedPromotionId`) to be
 * applied first so that `store.selectedPromotionId` is available.
 *
 * Data is fetched via `ProductStore.promotionProducts(promotionId)` and cached alongside all other
 * product entities in the global ProductStore.
 */
export function withPromotionItems() {
  return signalStoreFeature(
    type<{ state: { selectedPromotionId: string | null } }>(),
    withProps((store) => {
      const productStore = inject(ProductStore);
      const _view = signal<ReturnType<typeof productStore.productPromotionProducts> | undefined>(undefined);
      effect(() => {
        const promotionId = store.selectedPromotionId();
        untracked(() => _view.set(promotionId ? productStore.productPromotionProducts(promotionId) : undefined));
      });
      return {
        promotionItems: proxyListViewSignal(_view),
      };
    }),
  );
}
